module.exports = __webpack_public_path__ + "img/store_bg.2af4e54e.png";